import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const Card = createComponent<ElementWithProps<{ hasImage: boolean }>>(
  'div',
  ({ hasImage }) => ({
    className: cx(
      'relative flex flex-col overflow-visible bg-background-weak u:py-4xl sm:rounded-xl md:u:py-3xl',
      { 'mb-[60px] pb-9xl sm:mb-[40px] md:mb-[56px]': hasImage }
    )
  })
);

export const ImageWrapper = createComponent('div', {
  className:
    'relative mx-auto -mb-[220px] h-[220px] w-full shrink-0 sm:-mb-[200px] sm:h-[200px] md:-mb-[240px] md:h-[240px] md:w-[410px]'
});

export const Vehicle = createComponent('img', {
  className:
    'absolute left-1/2 top-1/2 h-full w-auto -translate-x-1/2 -translate-y-1/2 overflow-visible object-contain md:h-[304px] md:w-[520px] md:object-cover',
  loading: 'eager',
  decoding: 'async'
});

export const CarouselCard = createComponent('div', {
  className:
    'flex h-full w-[300px] flex-col gap-lg rounded-md border border-border-subtle bg-background-default p-2xl md:w-[268px] lg:w-[225px] xl:w-[241px]'
});
